import { request, API_V1_PREFIX } from "./client";

export interface Discipline {
  id: string;
  name: string;
  code?: string;
  description?: string;
  school_profile_id?: string;
}

export async function getDisciplines(
  token: string,
  schoolProfileId?: string,
): Promise<Discipline[]> {
  const query = schoolProfileId ? `?school_profile_id=${schoolProfileId}` : "";
  return request<Discipline[]>(
    `${API_V1_PREFIX}/disciplines${query}`,
    { method: "GET" },
    { token },
  );
}

export async function createDiscipline(
  token: string,
  data: {
    name: string;
    school_profile_id: string;
    code?: string;
    description?: string;
  },
): Promise<Discipline> {
  return request<Discipline>(
    `${API_V1_PREFIX}/disciplines`,
    {
      method: "POST",
      body: JSON.stringify(data),
    },
    { token },
  );
}

export async function getDisciplinesByClass(
  token: string,
  classId: string,
): Promise<Discipline[]> {
  return request<Discipline[]>(
    `${API_V1_PREFIX}/classes/${classId}/disciplines`,
    { method: "GET" },
    { token },
  );
}
